export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Tagesverbrauch',
            fill: true,
            tension: 0.4,
            borderWidth: 2.5,
            borderColor: 'rgba(251, 191, 36, 1)',
            backgroundColor: 'rgba(251, 191, 36, 0.18)',
            pointRadius: 0,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: 'rgba(251, 191, 36, 1)',
            pointHoverBorderColor: '#ffffff',
            pointHoverBorderWidth: 2,
            data: [0]
        }
    ]
};
